import { Appointment, APPOINTMENT_STATUS } from "@elixir/types";
import { updateAppointment } from "../../utils/bridges/methods";
import { Timestamp } from "firebase/firestore";
import { logAndGetErrorResponse } from "../error";
import { ControllerReturnType } from "../types";
import { convertDateToFirestoreTimestamp } from "../../firestore/utils";
import { generateAppointmentToken } from "./generate-appointment-token";
import {
  trackAppointmentActivity,
  AptActivityType,
} from "./appointment-activity";

export default async function checkInAppointment({
  appointment,
}: {
  appointment: Pick<Appointment, "aid" | "clinic_id" | "doctor_oid" | "date">;
}): Promise<ControllerReturnType> {
  try {
    const { aid } = appointment;
    await updateAppointment({
      data: {
        status: APPOINTMENT_STATUS.CHECKED_IN,
        visit_checkin: convertDateToFirestoreTimestamp(new Date()),
        full_date: convertDateToFirestoreTimestamp(new Date()),
        date: convertDateToFirestoreTimestamp(new Date()),
        token: await generateAppointmentToken({
          clinicId: appointment.clinic_id,
          doctorId: appointment.doctor_oid,
          date: new Date(appointment.date),
        }),
      },
      aid,
    });

    trackAppointmentActivity({
      aid,
      activity: AptActivityType.VISIT_CHECKED_IN,
    });
    return { success: true };
  } catch (e) {
    return logAndGetErrorResponse(e);
  }
}
